import axios, { AxiosInstance } from "axios";

/**
 * Service API base class - configures default settings/error handling for inheriting class
 */
export abstract class BaseService {
  protected readonly $http: AxiosInstance;

  protected constructor(controllerName: string, requestTimeout = 50000) {
    this.$http = axios.create({
      timeout: requestTimeout,
      baseURL: `https://etickets-api.equipovision.com/${controllerName}/`,
      // baseURL: `http://localhost:7500/${controllerName}/`,
      // local url http://localhost:7500/
    });
  }
}
